import React, { useEffect } from 'react';

import HowItWorks from '../components/sections/HowItWorks';
import ImpactBand from '../components/sections/ImpactBand';
import Benefits from '../components/sections/Benefits';
import Testimonials from '../components/sections/Testimonials';
import FAQs from '../components/sections/FAQs';
import ClosingBand from '../components/sections/ClosingBand';
import StickyMobileCTA from '../components/StickyMobileCTA';
import * as Util from '../Util';


const Home = ({ isAuthed, history }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (Util.isProduction()) {
      window.amplitude.getInstance().logEvent('Visited Homepage');
      window.fbq('track', 'ViewContent');
      window.mixpanel.track('Page View: Homepage');
    }
  }, []);

  const primaryCtaLabel = isAuthed ? 'Go to Dashboard' : 'Get started — 4 week results';
  const primaryCtaPath = isAuthed ? '/dashboard' : '/start/step1';

  const handlePrimaryCta = (location) => {
    if (Util.isProduction()) {
      if (window.amplitude) {
        window.amplitude.getInstance().logEvent('Hero CTA Clicked', { location, authed: !!isAuthed });
      }
      if (window.mixpanel) {
        window.mixpanel.track('Hero CTA Clicked', { location, authed: !!isAuthed });
      }
    }
    history.push(primaryCtaPath);
  };

  return (
    <div className="App Homepage">
      <section className="HeroSection">
        <div className="HeroSection__inner">
          <h1 className="brand-name">Stop paper junk mail — done for you.</h1>
          <p className="tagline">
            Show us your junk mail. We get you off their lists — 86% less in 4 weeks.
          </p>

          <div className="HeroSection__ctas">
            <button
              className="HeroSection__primary-cta"
              onClick={() => handlePrimaryCta('hero')}
            >
              {primaryCtaLabel}
            </button>
          </div>

          <div className="HeroSection__trust">
            <span className="HeroSection__trust-item">
              <span className="HeroSection__stars" aria-hidden="true">★★★★★</span>
              <span>"My mailbox has been extremely peaceful." — Tom, Brooklyn</span>
            </span>
          </div>
        </div>
      </section>
      <Benefits />
      <Testimonials />
      <HowItWorks />
      <ImpactBand />
      <FAQs />
      <ClosingBand isAuthed={isAuthed} history={history} />
      <StickyMobileCTA isAuthed={isAuthed} history={history} />
    </div>
  );
};

export default Home;
